import api from "./axios";
import type { CronJob } from "@/types";

export const getAll = (scraperId?: string) =>
  api
    .get<CronJob[]>("/cron-jobs", { params: scraperId ? { scraperId } : {} })
    .then((r) => r.data);

export const create = (data: {
  scraperId: string;
  name: string;
  expression: string;
}) => api.post<CronJob>("/cron-jobs", data).then((r) => r.data);

export const update = (
  id: string,
  data: Partial<{ name: string; expression: string }>,
) => api.patch<CronJob>(`/cron-jobs/${id}`, data).then((r) => r.data);

export const remove = (id: string) =>
  api.delete(`/cron-jobs/${id}`).then((r) => r.data);

export const start = (id: string) =>
  api.post<CronJob>(`/cron-jobs/${id}/start`).then((r) => r.data);

export const stop = (id: string) =>
  api.post<CronJob>(`/cron-jobs/${id}/stop`).then((r) => r.data);
